import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { Slash } from 'lucide-react';

import { CheckTransactionsTable } from './table';

export function GeoveraCheckTransactions() {
	//const nav = useNavigate();
	const id = window.location.pathname.split('/').pop();
	const fileIngestionId = id ? parseInt(id) : NaN;
	return (
		<>
			<Breadcrumb className="mb-4 pl-4">
				<BreadcrumbList>
					<BreadcrumbItem>
						<BreadcrumbLink href="/geovera/checks">Check Feed</BreadcrumbLink>
					</BreadcrumbItem>
					<BreadcrumbSeparator>
						<Slash />
					</BreadcrumbSeparator>
					<BreadcrumbItem>
						<BreadcrumbPage>Check Transactions</BreadcrumbPage>
					</BreadcrumbItem>
				</BreadcrumbList>
			</Breadcrumb>

			<Card className="w-full">
				<CardHeader>
					<span className="flex flex-row justify-between">
						<CardTitle className="mt-2">Check Transactions</CardTitle>
					</span>
					<CardDescription>File Id {fileIngestionId}</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<CheckTransactionsTable fileIngestionId={fileIngestionId} />
				</CardContent>
			</Card>
		</>
	);
}
